import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=754fda01&scoped=true&lang=pug&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=754fda01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754fda01",
  null
  
)

/* custom blocks */
import block0 from "~/lang/blog?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230928165100%2Fpages%2Fmedia%2F_year%2F_month%2F_day%2F_publication%2F_slug%2F_id.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/widgets/image.vue').default,WidgetsMedia: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/widgets/media.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/site/feefo.vue').default})
